import { RolesEnum } from './enums/roles.enum';

export function setColorScheme(companyColorScheme) {
  switch (companyColorScheme) {
    case 'blue': // blue(default)
      document.documentElement.style.setProperty('--hover-color', '#055AA9');
      document.documentElement.style.setProperty('--icons-color', '#177DDC');
      document.documentElement.style.setProperty('--main-color', '#177DDC');
      document.documentElement.style.setProperty('--text-color', '#fff');
      document.documentElement.style.setProperty('--toggle-color', '#338effa3');
      document.documentElement.style.setProperty('--message-color', '#D1E1FF');
      document.documentElement.style.setProperty('--people-color', '#EC1515');
      document.documentElement.style.setProperty('--transparent-color', '#177DDC33');
      document.documentElement.style.setProperty('--transparent-hover-color', '#177DDC80');
      break;
    case 'red': // red
      document.documentElement.style.setProperty('--hover-color', '#9D3939');
      document.documentElement.style.setProperty('--icons-color', '#E61A27');
      document.documentElement.style.setProperty('--main-color', '#EF4444');
      document.documentElement.style.setProperty('--text-color', '#fff');
      document.documentElement.style.setProperty('--toggle-color', '#f4000975');
      document.documentElement.style.setProperty('--message-color', '#5C2925');
      document.documentElement.style.setProperty('--people-color', '#000');
      document.documentElement.style.setProperty('--transparent-color', '#EF444433');
      document.documentElement.style.setProperty('--transparent-hover-color', '#EF444480');
      break;
    case 'green': // green
      document.documentElement.style.setProperty('--hover-color', '#046F4E');
      document.documentElement.style.setProperty('--icons-color', '#1DA8A0');
      document.documentElement.style.setProperty('--main-color', '#009163');
      document.documentElement.style.setProperty('--text-color', '#fff');
      document.documentElement.style.setProperty('--toggle-color', '#00bb8e9c');
      document.documentElement.style.setProperty('--message-color', '#BFE3D8');
      document.documentElement.style.setProperty('--people-color', '#EC1515');
      document.documentElement.style.setProperty('--transparent-color', '#00916333');
      document.documentElement.style.setProperty('--transparent-hover-color', '#00916380');
      break;
    case 'purple': // purple
      document.documentElement.style.setProperty('--hover-color', '#5B46AB');
      document.documentElement.style.setProperty('--icons-color', '#8D72F4');
      document.documentElement.style.setProperty('--main-color', '#8D72F4');
      document.documentElement.style.setProperty('--text-color', '#fff');
      document.documentElement.style.setProperty('--toggle-color', '#6600998c');
      document.documentElement.style.setProperty('--message-color', '#3F3B5A');
      document.documentElement.style.setProperty('--people-color', '#EC1515');
      document.documentElement.style.setProperty('--transparent-color', '#8D72F433');
      document.documentElement.style.setProperty('--transparent-hover-color', '#8D72F480');
      break;
    case 'yellow': // yellow
      document.documentElement.style.setProperty('--hover-color', '#E2A60D');
      document.documentElement.style.setProperty('--icons-color', '#E59A30');
      document.documentElement.style.setProperty('--main-color', '#E59A30');
      document.documentElement.style.setProperty('--text-color', '#fff');
      document.documentElement.style.setProperty('--toggle-color', '#ff66008f');
      document.documentElement.style.setProperty('--message-color', '#764B0F');
      document.documentElement.style.setProperty('--people-color', '#EC1515');
      document.documentElement.style.setProperty('--transparent-color', '#FFC53033');
      document.documentElement.style.setProperty('--transparent-hover-color', '#FFC53080');
      break;
  }
}

export function setModeTheme(role, mode: boolean) {
  if (localStorage.getItem('color_scheme') == 'kpmg') {
    setColorScheme('blue');
  }
  if (mode) {
    document.documentElement.style.setProperty('--layout-background', '#191919');
    document.documentElement.style.setProperty('--table-color', '#303030');
    document.documentElement.style.setProperty('--table-hover', '#3C3C3C');
    document.documentElement.style.setProperty('--table-wrapper', '#202020');
    document.documentElement.style.setProperty('--border-component', '#3C3C3C');
    document.documentElement.style.setProperty('--table-cell-color', '#8C8C8C');
    document.documentElement.style.setProperty('--profile-background', 'transparent');
    document.documentElement.style.setProperty('--activity-wrap', '#191919');
    document.documentElement.style.setProperty('--item-background', '#363636');
    document.documentElement.style.setProperty('--my-msg-color', '#525252');
    document.documentElement.style.setProperty('--mdc-dialog-container-color', '#303030');
    document.documentElement.style.setProperty('--general-text-color', '#fff');
    document.documentElement.style.setProperty('--border-color', '#474747');
    if (role == RolesEnum.admin || localStorage.getItem('color_scheme') == 'kpmg') {
      document.documentElement.style.setProperty('--layout-background', '#041338');
      document.documentElement.style.setProperty('--table-color', '#182648');
      document.documentElement.style.setProperty('--table-hover', '#2A3656');
      document.documentElement.style.setProperty('--table-wrapper', '#0E1C40');
      document.documentElement.style.setProperty('--border-component', '#2A3656');
      document.documentElement.style.setProperty('--table-cell-color', '#8E95A5');
      document.documentElement.style.setProperty('--mdc-dialog-container-color', '#182648');
      document.documentElement.style.setProperty('--profile-background', '#0E1C40');
      document.documentElement.style.setProperty('--activity-wrap', '#041338');
      document.documentElement.style.setProperty('--item-background', '#182648');
      document.documentElement.style.setProperty('--my-msg-color', '#24417A');
    }
  } else {
    document.documentElement.style.setProperty('--layout-background', '#F8F8F8');
    document.documentElement.style.setProperty('--table-color', '#F8FAFF');
    document.documentElement.style.setProperty('--table-hover', '#E7ECF8');
    document.documentElement.style.setProperty('--mat-paginator-container-background-color', '#EBEFF8');
    document.documentElement.style.setProperty('--mdc-dialog-container-color', '#fff');
    document.documentElement.style.setProperty('--general-text-color', '#0B1F46');
    document.documentElement.style.setProperty('--border-color', '#E7E9EC');
    if (role == RolesEnum.admin || localStorage.getItem('color_scheme') == 'kpmg') {
      document.documentElement.style.setProperty('--layout-background', '#EBEFF8');
      document.documentElement.style.setProperty('--table-color', '#F8FAFF');
      document.documentElement.style.setProperty('--table-hover', '#E7ECF8');
      document.documentElement.style.setProperty('--mat-paginator-container-background-color', '#EBEFF8');
    }
  }

}
